import { Component } from "react";
import LayoutWrapper from "../../../LayoutWrapper";
import "../module.scss";
import AssessmentsDetailsPage from "./AssessmentsDetailsPage";

export class PreviewAssessmentsPage extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("PreviewAssessmentsPage");
    this.state = {
      data: {
        assessment_answers: [
          {
            q_label:
              "Select the three most important values you consider a person should have",
            correct_answer: true,
            value: "ABCD",
            customer_answer: "ABCD",
          },
          {
            q_label:
              "Select the three most important values you consider a person should have",
            correct_answer: false,
            value: "123",
            customer_answer: "456",
          },
        ],
      },
    };
  }

  get errors() {
    return Object.entries(this.errorsMessages)
      .filter(([key, val]) => val)
      .map(([key, val]) => key);
  }

  get isValid() {
    let data = this.formData;
    let keys = Object.keys(data);
    // let { fields = [] } = this.state.form || {};
    let fields = this.state.form || [];
    return keys.reduce((flag, key) => {
      let field = fields.find((o) => o.label == key || o.name == key) || {};
      let constraints = field.fieldConstraint
        .filter((v) => v)
        .map((v) => _enum.CONSTRAINTS_LMS_MAP[v]);
      let value = data[key];
      let valid = constraints.reduce(
        (flag, v) =>
          flag &&
          ((typeof v == "string" && value.match(new RegExp(v))) ||
            (typeof v == "function" &&
              v(field.fieldType == "date" ? value.date() : value))),
        true
      );
      if (!constraints.includes("mandatory") && !value) {
        valid = true;
      }
      if (!valid) {
        this.errorsMessages[key] = true;
      } else {
        this.errorsMessages[key] = false;
      }
      return flag && !!valid;
    }, true);
  }

  get formData() {
    return this.refs.form.form.current.getData();
  }

  componentDidMount() {
    // this.fetchData();
    this.getBreadCums();
  }

  fetchData() {
    this.props.api
      .getTableAssessmentPreviewById({
        assessment_id: this.props.urlparams.assessment_id,
      })
      .then(({ data }) => {
        console.log(data);
        this.setState({ data: data });
      });
  }

  getBackLink() {
    let backLink = `/mycontent/sessions?id=1`;
    return backLink;
  }

  getBreadCums() {
    return "My Content / The LABWORLD Algebra Kit ..../  Assessment Name  Preview Assessment";
  }

  getTitle() {
    return "My Content";
  }

  render() {
    let {} = this.state;
    return (
      <LayoutWrapper
        title={this.getTitle()}
        back={this.getBreadCums()}
        backlink={this.getBackLink()}
      >
        <AssessmentsDetailsPage
          data={this.state.data}
          isPreview={this.props.urlparams?.isPreview}
        />
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-success btn-block ms-2 px-4 text-end"
            onClick={() => this.props.navigate(this.getBackLink())}
          >
            Close
          </button>
        </div>
      </LayoutWrapper>
    );
  }
}

export default connect(PreviewAssessmentsPage);
